import { UserState } from './reducers';

export const getTimeZone = (state: UserState) => state.timeZone;
